import styled from 'styled-components';

export const StyledAsterisco = styled.span`
  &::after {
    content: '*';
    color: red;
  }
`;

export const TitleLabel = styled.div`
  padding-bottom: 10px;
`;
export const ModalContainer = styled.div`
  padding-bottom: 10px;
  h2 {
    color: #096dd9;
    font-weight: 400;
    font-size: 20px;
  }
  p {
    font-size: 14px;
    color: #8c8c8c;
  }
  .boxinputs {
    background-color: #fafafa;
    border: solid 1px #d9d9d9;
    padding: 1rem;
  }
`;
